import './App.css';
import { useState } from 'react';
import whiteArrow from './imgs/arrow-white.png';

/**
 * Renders a question component with selectable answers and a continue button.
 * 
 * @param {Object} props - The properties passed to the Question component.
 * @param {Array} props.currentQuestion - The current question and its possible answers.
 * @param {number} props.currentStep - The current step in the questionnaire.
 * @param {number} props.longevity - The longevity value used for determining certain answers.
 * @param {boolean} props.showNextQestion - Indicates whether to show the next question.
 * @param {number} props.active - The index of the currently active answer.
 * @param {string} props.selectedValue - The currently selected answer value.
 * @param {number} props.currentId - The ID of the current question.
 * @param {string} props.id - The ID used for handling the next question.
 * @param {function} props.handleSetActive - Function to set the active answer.
 * @param {function} props.handleShowNextQuestion - Function to toggle showing the next question.
 * @param {function} props.handleSetSelectedValue - Function to set the selected answer value.
 * @param {function} props.handleNextQuestion - Function to handle moving to the next question.
 * @returns {JSX.Element} The rendered Question component.
 */
function Question(props) {
    let listQuestions;
    let [varvalue, setvarvalue] = useState('home');

    // Dynamicly set button value if linkId has multiple values
    let dynamicValue = (question) => {
        if(Array.isArray(question.answerId)){
            if(props.currentStep == 3){
                if(question.variableId == "appointed-date" || question.variableId[0] == "appointed-month"){ 
                    if(props.longevity >= 1 && (props.jobTitle === 'occupational-therapist' || props.jobTitle === 'physical-therapist' || props.jobTitle === 'audiologist')){
                        return question.answerId[2]
                    }
                    else if(props.longevity < 5) {
                        return question.answerId[0]
                    }
                    else if(props.longevity >= 22) {
                        return question.answerId[1]
                    }
                    else{
                        return question.answerId[2]
                    }
                }
            }
        }
        else{
            return question.answerId;
        }
    }

    // Function to handle user selection of an answer
    function handleSelectAnsnwer(event){
        const selectedValue = event.currentTarget.value;
        const varValue = event.currentTarget.getAttribute('data-varvalue');
        
        props.handleSetActive(Number(event.currentTarget.id));
        props.handleSetSelectedValue(selectedValue);

        // Call handleNextQuestion directly
        props.handleNextQuestion(event, props.id, varValue);
    }

    // Render questions based on the current question
    const questions = props.currentQuestion;
    if(questions && Array.isArray(questions)){
        listQuestions = questions.map((question, index) =>
            <button onClick={handleSelectAnsnwer} className={props.active === index ? 'default-button active' : 'default-button'} data-answer={question.question} id={index} key={index} value={dynamicValue(question)} data-varvalue={question.value} data-current={props.currentId}>{question.question}</button>
        )
    }

  return (
    <>
     <div className="question-wrapper">
      {listQuestions}
    </div>
    </>
  );
}

export default Question;